/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { useIntl } from 'react-intl';

import { cssMap, jsx } from '@atlaskit/css';
import { Box, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import messages from './messages';

const chartErrorStyles = cssMap({
	errorContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
		backgroundColor: token('color.background.neutral'),
	},
});

interface ChartErrorProps {
	testId?: string;
	errorType?: 'unsupported' | 'general';
	chartType?: string;
	supportedTypes?: readonly string[];
}

// Unified error component for various chart errors
export const ChartError = ({
	testId,
	errorType = 'general',
	chartType,
	supportedTypes,
}: ChartErrorProps): JSX.Element => {
	const intl = useIntl();

	const containerProps = testId ? { testId: `${testId}-error` } : {};

	const isUnsupportedError =
		errorType === 'unsupported' && chartType !== undefined && supportedTypes;

	return (
		<Box xcss={chartErrorStyles.errorContainer} {...containerProps}>
			<Box>
				<Box>
					<Text color="color.text.danger">
						{isUnsupportedError
							? intl.formatMessage(messages.unsupportedChartType, { chartType })
							: intl.formatMessage(messages.chartRenderError)}
					</Text>
				</Box>
				<Text color="color.text.subtle" size="small">
					{isUnsupportedError
						? intl.formatMessage(messages.supportedChartTypes, {
								supportedTypes: supportedTypes.join(', '),
							})
						: intl.formatMessage(messages.chartRenderErrorDetails)}
				</Text>
			</Box>
		</Box>
	);
};

export default ChartError;
